
import React, { FC, JSX } from "react";
import UserManagementTable from "../../components/user/UserManagementTable";

const AgentAllUsers: FC = (): JSX.Element => {
  return (
    <UserManagementTable
      isAdminView={false} // Agent view
      pageTitle="All Users"
      pageDescription="View and manage all registered users on the platform"
      filterRole={["Jobseeker", "Company"]}
      showFilters={{
        role: true,
        isMobileVerified: true,
        paymentStatus: true,
        status: true,
      }}
      columns={["Profile", "Name", "Email", "Mobile", "Role", "Status", "Attachments"]}
    />
  );
};

export default AgentAllUsers;
